<template>
    <div>
        <VerifyFile v-if="uploadFiles.length !== 0" :items="uploadFiles" :onFileChange="onFileChange" :resetFile="resetFile" :handleDelete="handleDelete" />
        <VerifyHash />
        <div class="content" v-if="uploadFiles.length === 0">
            <div class="tab-container d-flex h-100 flex-column align-items-center justify-content-center" @dragover.prevent @drop.prevent>
                <p class="title">選擇驗證證據</p>
                <div class="d-flex mb-3">
                    <button class="btn-primary-sm mx-3" v-b-modal.modal-hash-input>
                        輸入雜湊值
                    </button>
                    <button class="btn-primary-sm mx-3" @click="handleUploadButtonClick()">
                        選擇檔案
                    </button>
                </div>
                <label class="btn-upload" @drop="dragFile">
                    <input type="file" ref="input" multiple v-on:change="onFileChange" />
                </label>
            </div>
            <div class="footer"></div>
        </div>
    </div>
</template>
<script>
import VerifyFile from './VerifyFile.vue'
import VerifyHash from './VerifyHash.vue'
import { sha256 } from '../utils/functions.js'
export default {
    name: "VerifyPage",
    components: {
        VerifyFile,
        VerifyHash
    },
    data() {
        return {
            uploadFiles: [],
            uploadHashs:[],
        }
    },
    methods: {
        handleUploadButtonClick() {
            this.$refs.input.click();
        },
        resetFile() {
            this.uploadFiles = [];
        },
        handleDelete(index) {
            this.uploadFiles.splice(index, 1);
            this.uploadFiles = this.uploadFiles.map((file, i) => {
                return {
                    ...file,
                    index: i + 1
                }
            })
        },
        async onFileChange(event) {
            const files = event?.target?.files;
            if (files) {
                const indexStart = this.uploadFiles.length + 1
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    const hashString = await sha256(file);
                    this.uploadFiles.push({
                        index: i + indexStart,
                        fileName: file.name,
                        hash: hashString,
                        _rowVariant: 'light',
                    });
                }
            }
        },
        async dragFile(event) {
            const files = event?.dataTransfer?.files;
            if (files) {
                const indexStart = this.uploadFiles.length + 1
                for (let i = 0; i < files.length; i++) {
                    const file = files[i];
                    const hashString = await sha256(file);
                    this.uploadFiles.push({
                        index: i + indexStart,
                        fileName: file.name,
                        hash: hashString,
                        _rowVariant: 'light',
                    });
                }
            }
        }
    },
    mounted() {
        if (!sessionStorage.getItem('username') && !sessionStorage.getItem('organs')) {
            this.$router.push('/');
        }
    }
};
</script>